import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

const config = {
  apiKey: 'AIzaSyAWCMKF2Bt7egYMoYYO-4P7v9DtWFuGLDk',
  authDomain: 'my-anatomy-90e22.firebaseapp.com',
  databaseURL: 'https://my-anatomy-90e22.firebaseio.com',
  storageBucket: 'my-anatomy-90e22.appspot.com',
  messagingSenderId: '355297796959',
};

firebase.initializeApp(config);

export const auth = firebase.auth();
export const database = firebase.database();



// WEBPACK FOOTER //
// ./src/utils/configureFirebase.js